export const notifyError = (dispatch, message, error) => {
    return dispatch(
        'notifier/error',
        {
            message,
            error,
            component: 'dialog'
        },
        {
            root: true
        }
    );
};

export const notifySuccess = (dispatch, message) => {
    return dispatch('notifier/success', { message }, { root: true });
};
